import { render, staticRenderFns } from "./WsPocketImagePickerPocket.vue?vue&type=template&id=abb89424&"
import script from "./WsPocketImagePickerPocket.vue?vue&type=script&lang=js&"
export * from "./WsPocketImagePickerPocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports